import { compose } from 'redux';
export const composeEnhancers = (process.env.NODE_ENV === 'development' &&
    window &&
    // eslint-disable-next-line no-underscore-dangle
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;
